s
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { apiRequest } from "@/helpers/api-call";
import { format } from "date-fns";
import router from "@/router/index.js";

/**
 * Orders Component
 */
export default {
  page: {
    title: "Utilisateurs Suspendus",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      title: "liste des utilisateurs suspendus",
      items: [
        {
          text: "Dashboard",
        },
        {
          text: "Suspendu",
          active: true,
        },
      ],
      value: null,
      value1: null,
      options: ["Sexe", "Taille", "Vehicule", "je vois"],
      dataUser: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [100,250,500],
      filter: null,
      filterOn: [],
      sortBy: "orderid",
      sortDesc: false,
      fields: [
        { key: "username", sortable: true, label: "Utilisateur" },
        { key: "tel", sortable: true, label: "Téléphone" },
        { key: "trajet", sortable: true, label: "Trajet effectué" },
        { key: "dateIns", sortable: true, label: "Inscription" },
        { key: "badge", label: "Détenteur badge" },
        { key: "statut", sortable: true, label: "Activer/Désactiver" },
        { key: "action", label: "Actions" },
      ],
      showDelete: false,
      showEdit: false,
      showRestore: false,
      showMessage: false,
      editor: ClassicEditor,
      editorData: "<p>Contenu du message.</p>",
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.dataUser.length;
    },
  },
  async mounted() {
    //Chargement des données
    const data = await apiRequest(
      "GET",
      "admin/users-inactif",
      undefined,
      false
    );
    if (data && data.data) {

      const formattedTable = data.data.map((user) => {
        return {
          id: user.id,
          username: user.lastname[0] + ". " + user.firstname,
          tel: user.tel,
          trajet: user.id,
          dateIns: format(new Date(user.dateCreation), "dd-MM-yyyy hh:mm:ss"),
          badge: user.userValidated,
          statut: user.active ? "Actif" : "Suspendu",
        };
      });
      this.dataUser = formattedTable;
    }
    // Set the initial number of items
    this.totalRows = this.dataUser.length;
  },
  methods: {
    EditModal() {
      this.submitted = false;
      this.showEdit = false;
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToDetail(row) {
     
      router.push(`/user/user_info/${row.id}`)
  
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body pt-0">
            <b-tabs nav-class="nav-tabs-custom">
              <b-tab title-link-class="p-3">
                <template v-slot:title>
                  <a class="font-weight-bold active">All Orders</a>
                </template>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-3">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Afficher&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entrées
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <label class="d-inline-flex align-items-center">
                      Choisir
                      <multiselect
                        v-model="value1"
                        :options="options"
                        :multiple="true"
                        :searchable="false"
                        class="col-md-12"
                      ></multiselect>
                    </label>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-3">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <div class="table-responsive">
                  <b-table
                    class="table-centered"
                    :items="dataUser"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    @row-clicked="goToDetail"
                  >
                    <template v-slot:cell(badge)="row">
                      <div
                        class="text-center"
                        :class="{
                          'fa fa-star': `${row.value}` === 'false',
                          'fa fa-star badge-soft-warning':
                            `${row.value}` === 'true',
                        }"
                      ></div>
                    </template>
                    <template v-slot:cell(statut)="row">
                      <div
                        class="badge font-size-12"
                        :class="{
                          'badge-soft-danger': `${row.value}` === 'Suspendu',
                          'badge-soft-success': `${row.value}` === 'Actif',
                        }"
                      >
                        {{ row.value }}
                      </div>
                    </template>
                    <template v-slot:cell(action)>
                      <a
                        href="javascript:void(0);"
                        @click="showRestore = true"
                        class=" text-success"
                        v-b-tooltip.hover
                        title="restaurer"
                      >
                        <i class="mdi mdi-check font-size-18"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="text-danger"
                        v-b-tooltip.hover
                        @click="showDelete = true"
                        title="Désactiver"
                      >
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-backdrop"
      centered
      v-model="showDelete"
      title="Voulez-vous vraiment supprimer cet utilisateur ?"
      title-class="font-18"
    >
    </b-modal>
    <b-modal
      id="modal-center"
      centered
      size="xl"
      v-model="showEdit"
      title="Editer utilisateur"
      title-class="font-18"
      hide-footer
    >
      <form
        class="form-horizontal"
        role="form"
        method="post"
        @submit.prevent="EditSubmit"
      >
        <div class="row">
          <div class="col-md-4 mb-3">
            <label for="lastname">Nom</label>
            <input
              type="text"
              class="form-control py-4"
              id="lastname"
              placeholder=""
              v-model.trim="lastname"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Prénom</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="firstname"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="genre">Genre</label>
            <div class="input-group">
              <select
                name=""
                id="genre"
                class="form-control py-4"
                v-model="selected"
              >
                <option value="" disabled>Autre</option>
                <option>Masculin</option>
                <option>Féminin</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="lastname">Boîte postale</label>
            <input
              type="text"
              class="form-control py-4"
              id="lastname"
              placeholder=""
              v-model.trim="boite_postale"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Profession</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="profession"
            />
          </div>
          <div class="col-md-4 mb-3">
            <div class="mb-3">
              <label for="birthday">Date de naissance</label>
              <date-picker
                id="birthday"
                type="date"
                v-model.trim="birthday"
                :first-day-of-week="1"
              ></date-picker>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="lastname">Adresse</label>
            <input
              type="text"
              class="form-control py-4"
              id="lastname"
              placeholder=""
              v-model.trim="adress"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Ville</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="city"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Pays</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="country"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="lastname">Téléphone</label>
            <input
              type="text"
              class="form-control py-4"
              id="lastname"
              placeholder=""
              v-model.trim="number_phone"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Email</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="email"
            />
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstname">Mot de passe</label>
            <input
              type="text"
              class="form-control py-4"
              id="firstname"
              placeholder=""
              v-model.trim="password"
            />
          </div>
        </div>
        <button class="btn btn-success float-right" type="submit">
          Modifier
        </button>
      </form>
    </b-modal>

    <!-- -->
    <b-modal v-model="showMessage" title="Nouveau Message" centered>
      <form>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Sujet" />
        </div>
        <div class="form-group">
          <ckeditor v-model="editorData" :editor="editor"></ckeditor>
        </div>
      </form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = false"
          >Fermer</b-button
        >
        <b-button variant="primary">
          Envoyer
          <i class="fab fa-telegram-plane ml-1"></i>
        </b-button>
      </template>
    </b-modal>
    <!-- -->

    <b-modal
      id="modal-1"
      v-model="showRestore"
      centered
      title="Voulez-vous restaurer cet utilisateur ?"
      title-class="text-dark font-18"
      hide-footer
    >
    </b-modal>
  </Layout>
</template>
